import LookalikeSizeSubmitting from './LookalikeSizeSubmitting';

export default LookalikeSizeSubmitting;
